__turbopack_context__.v({
  "active": "sports-layout-module-sass-module__NLiGbq__active" + " " + __turbopack_context__.i(254415)["active"],
  "favorites": "sports-layout-module-sass-module__NLiGbq__favorites" + " " + __turbopack_context__.i(254415)["sportItem"] + " " + __turbopack_context__.i(254415)["base"],
  "gamesCount": "sports-layout-module-sass-module__NLiGbq__gamesCount" + " " + __turbopack_context__.i(254415)["gamesCount"],
  "noGame": "sports-layout-module-sass-module__NLiGbq__noGame",
  "popoverContent": "sports-layout-module-sass-module__NLiGbq__popoverContent",
});
